<template>
    <div class="admin-panel">
        <div v-if="loadingAuth" class="admin-state">
            <vue-feather type="loader" animation="spin" size="32"></vue-feather>
            <span>{{ t('Checking access...', 'சரிபார்க்கிறது...') }}</span>
        </div>

        <div v-else-if="!isAdmin" class="admin-state denied">
            <vue-feather type="lock" size="38" stroke-width="1.8"></vue-feather>
            <h1>{{ t('Access denied', 'அணுகல் மறுக்கப்பட்டது') }}</h1>
            <p>{{ t('This area is only available to admins.', 'இந்த பகுதி நிர்வாகிகளுக்கே மட்டுமே.') }}</p>
        </div>

        <div v-else class="admin-layout">
            <aside class="admin-sidebar">
                <div class="admin-brand">
                    <vue-feather type="shield" size="18"></vue-feather>
                    <span>{{ t('Admin', 'நிர்வாகம்') }}</span>
                </div>
                <nav class="admin-nav">
                    <router-link
                        v-for="item in navItems"
                        :key="item.to"
                        :to="item.to"
                        class="admin-nav-item"
                        active-class="active"
                    >
                        <vue-feather :type="item.icon" size="18"></vue-feather>
                        <span>{{ item.label }}</span>
                    </router-link>
                </nav>
            </aside>

            <section class="admin-content">
                <router-view />
            </section>
        </div>
    </div>
</template>

<script>
import { isAdminUser } from '../utils/auth';

export default {
    name: 'AdminPanel',
    inject: {
        languageRef: { from: 'currentLanguage', default: 'EN' }
    },
    data() {
        return {
            loadingAuth: true,
            isAdmin: false,
        };
    },
    computed: {
        currentLanguage() {
            return this.languageRef || 'EN';
        },
        navItems() {
            return [
                { to: '/admin/pending-videos', icon: 'inbox', label: this.t('Pending videos', 'நிலுவை காணொளிகள்') },
                { to: '/admin/import-url', icon: 'download', label: this.t('Import from URL', 'URL இருந்து இறக்குமதி') },
                { to: '/admin/categories', icon: 'grid', label: this.t('Categories', 'வகைகள்') },
                { to: '/admin/users', icon: 'users', label: this.t('Users', 'பயனர்கள்') },
                { to: '/admin/emails', icon: 'mail', label: this.t('Email campaigns', 'மின்னஞ்சல் பிரச்சாரங்கள்') },
            ];
        },
    },
    async mounted() {
        this.isAdmin = await isAdminUser();
        this.loadingAuth = false;
    },
    methods: {
        t(en, ta) {
            return this.currentLanguage === 'TA' ? ta : en;
        },
    },
};
</script>

<style scoped>
.admin-panel {
    max-width: 1280px;
    margin: 20px auto;
    padding: 0 20px 40px;
}

.admin-layout {
    display: grid;
    grid-template-columns: 220px 1fr;
    gap: 24px;
    align-items: start;
}

.admin-sidebar {
    position: sticky;
    top: 20px;
    background: var(--bg-card);
    border: 1px solid var(--border-color);
    border-radius: 10px;
    padding: 14px;
}

.admin-brand {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 6px 8px 12px;
    color: #ff1314;
    font-size: 13px;
    font-weight: 800;
    text-transform: uppercase;
    letter-spacing: 0.4px;
    border-bottom: 1px solid var(--border-color);
    margin-bottom: 10px;
}

.admin-nav {
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.admin-nav-item {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 12px;
    border-radius: 8px;
    color: var(--text-secondary);
    font-size: 15px;
    font-weight: 600;
    text-decoration: none;
    transition: background 0.15s, color 0.15s;
}

.admin-nav-item:hover {
    background: var(--bg-hover);
    color: var(--text-primary);
}

.admin-nav-item.active {
    background: rgba(255, 19, 20, 0.12);
    color: #ff1314;
}

.admin-content {
    min-width: 0;
}

.admin-state {
    min-height: 260px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 12px;
    text-align: center;
    color: var(--text-secondary);
    background: var(--bg-card);
    border-radius: 8px;
    box-shadow: 0 2px 8px var(--shadow-color);
    padding: 32px;
}

.admin-state h1 {
    margin: 0;
    color: var(--text-primary);
}

.admin-state.denied {
    color: #ff1314;
}

@media (max-width: 820px) {
    .admin-layout {
        grid-template-columns: 1fr;
    }

    .admin-sidebar {
        position: static;
    }

    .admin-nav {
        flex-direction: row;
        flex-wrap: wrap;
    }
}
</style>
